import React from 'react';
import { HeartHandshake } from 'lucide-react';
import type { PatientPrograms } from '../../../dtos/patientmr/programs.dto';
import { ProgramsService } from '../../../services/patientmr/programs.service';

const formatDate = (value: string | null | undefined): string => {
  if (!value) return '';
  const [y, m, d] = value.slice(0, 10).split('-');
  return y && m && d ? `${m}/${d}/${y}` : value;
};

/**
 * Phase 20F chart header banner: palliative care programme and hospice election, shown on every
 * tab (next to the out-of-hospital DNR banner). Renders nothing when neither is in effect.
 */
const ProgramBadges: React.FC<{ programs: PatientPrograms | null; compact?: boolean }> = ({ programs, compact = false }) => {
  const palliative = ProgramsService.palliativeActive(programs);
  const hospice = ProgramsService.hospiceActive(programs);
  if (!palliative && !hospice) return null;
  const h = programs?.hospice?.data;
  return (
    <div role="note" aria-label="Patient programmes" data-testid="program-badges"
      className={`flex flex-wrap items-center gap-2 border-b border-violet-200 bg-violet-50 text-violet-900 ${compact ? 'px-2 py-1 text-xs' : 'px-5 py-1.5 text-sm'}`}>
      <HeartHandshake size={compact ? 14 : 16} className="flex-shrink-0" aria-hidden="true" />
      {palliative && <span className="rounded-full bg-violet-100 px-2 py-0.5 font-medium" data-testid="badge-palliative">Palliative care programme</span>}
      {hospice && (
        <span className="rounded-full bg-amber-100 px-2 py-0.5 font-medium text-amber-900" data-testid="badge-hospice">
          Hospice elected {formatDate(h?.electionDate)}{h?.hospiceName ? ` · ${h.hospiceName}` : ''}
        </span>
      )}
    </div>
  );
};

export default ProgramBadges;
